import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowDown, Crosshair, Terminal } from "lucide-react";
export default function EngineeringPrecisionForIndustrialProgress() {
  return <section data-section-id="224938" id="expertos-en-recambios-de-obra-pública" className="bg-background text-foreground relative min-h-screen w-full overflow-hidden flex flex-col justify-center">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes scan {
            0% { top: -10%; opacity: 0; }
            10% { opacity: 1; }
            90% { opacity: 1; }
            100% { top: 110%; opacity: 0; }
          }
          @keyframes border-pulse {
            0% { box-shadow: 0 0 0 0 rgba(255, 102, 0, 0.4); }
            70% { box-shadow: 0 0 0 15px rgba(255, 102, 0, 0); }
            100% { box-shadow: 0 0 0 0 rgba(255, 102, 0, 0); }
          }
          .animate-scan {
            animation: scan 6s linear infinite;
          }
          .animate-border-pulse {
            animation: border-pulse 2s infinite;
          }
        `
    }} />

      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/HITACHI-1.jpg)] bg-cover bg-center grayscale-0 contrast-[1.4] brightness-[0.7]" />
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_70%,transparent_100%)]" />
      </div>

      {}
      <div className="absolute left-0 w-full h-[2px] bg-primary/60 z-10 animate-scan pointer-events-none mix-blend-screen" />

      {}
      <div className="container relative z-20 mx-auto px-4 md:px-8 h-full flex flex-col justify-center">
        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          
          {}
          <div className="lg:col-span-3 hidden md:flex flex-col gap-6 font-mono text-xs text-muted-foreground border-l border-primary/40 pl-4 py-4 backdrop-blur-md bg-background/40">
            <div className="flex items-center gap-2 text-primary">
              <Terminal className="size-4" />
              <span>CONNECTING BARCELONA SL</span>
            </div>
            <div className="space-y-1">
              <p className="uppercase tracking-widest text-foreground/80 font-bold">ESPECIALISTAS EN:</p>
              <p>HITACHI / FIAT / NEW-HOLLAND</p>
              <p>CASE / KOBELCO</p>
              <p>DOOSAN / HYUNDAI</p>
            </div>
            <div className="space-y-1">
              <p className="uppercase tracking-widest text-foreground/80 font-bold">DISPONIBILIDAD</p>
              <p>STOCK: INMEDIATO</p>
              <p>ENVÍO: 24/48H</p>
            </div>
            <div className="space-y-1">
              <p className="uppercase tracking-widest text-foreground/80 font-bold">ESTADO</p>
              <p className="text-primary animate-pulse">● CONECTADO</p>
            </div>
          </div>

          {}
          <div className="flex flex-col items-start !opacity-[1] !text-[rgba(250,250,250,1)] !border-1 border-[rgb(250,250,250)] !border-none lg:col-span-9">
            {}
            <h1 className="font-default font-black text-[clamp(2.5rem,7vw,6.5rem)] leading-[0.9] tracking-tighter text-transparent bg-clip-text bg-gradient-to-b from-foreground via-foreground to-foreground/60 mb-8 uppercase">
              Recambios<br />Maquinaria
            </h1>
            
            

            <div className="flex flex-wrap gap-4 relative group">
              {}
              <div className="absolute -inset-1 bg-primary/10 animate-ping opacity-10" />
              <div className="absolute inset-0 border border-primary/30 animate-border-pulse pointer-events-none" />
              
              <Button asChild size="lg" className="relative rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300 h-16 px-10 text-lg font-default font-bold tracking-tight uppercase">
                
              </Button>

              <Button asChild size="lg" variant="outline" className="relative rounded-md border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 h-16 px-10 text-lg font-default font-bold tracking-tight uppercase">
                
              </Button>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center justify-center z-20 opacity-80 hover:opacity-100 transition-opacity cursor-pointer">
        <div className="w-[1px] h-16 bg-gradient-to-b from-transparent via-primary/50 to-primary mb-2" />
        <div className="relative">
          <ArrowDown className="size-6 text-primary animate-bounce" />
          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 border border-primary/40 rotate-45 rounded-sm" />
        </div>
        <span className="mt-4 font-mono text-[10px] tracking-[0.3em] text-primary font-bold uppercase">Explorar</span>
      </div>
    </section>;
}